import React, { Component } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/api";
import { canAccess } from "../utils/permissions";
import "../styles/Navbar.css";

// Icon components for each nav item
const CaptureIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const HarvestIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L2 7l10 5 10-5-10-5z" />
    <path d="M2 17l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
);

const QCIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const SessionIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const ManageIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const RejectionsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const DashboardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3h18v18H3z" />
    <path d="M9 9h6v6H9z" />
  </svg>
);

const MenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const LeafIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
  </svg>
);

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      menuOpen: false,
      profileOpen: false,
      scrolled: false,
      harvestAccess: false
    };
    this.profileRef = React.createRef();
    this.menuButtonRef = React.createRef();
    this.closeButtonRef = React.createRef();
  }

  loadHarvestRights = () => {
    if (!this.props.auth.user) { this.setState({harvestAccess:false}); return; }
    api.get('field-harvest/qr/rights/').then(({data}) => {
      if (this.mounted) this.setState({harvestAccess:Object.values(data.rights).some(Boolean)});
    }).catch(() => { if(this.mounted) this.setState({harvestAccess:false}); });
  };

  componentDidUpdate(previous) {
    if (previous.auth.user !== this.props.auth.user || previous.location.pathname !== this.props.location.pathname) this.loadHarvestRights();
    if (previous.location.pathname !== this.props.location.pathname || previous.location.search !== this.props.location.search) {
      this.closeDesktopMenus();
      this.closeProfile();
      if (this.state.menuOpen) this.closeMenu();
    }
  }

  componentDidMount() {
    this.mounted = true;
    this.loadHarvestRights();
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleKeyDown);
    document.body.style.overflow = "";
  }

  handleScroll = () => {
    this.setState({ scrolled: window.scrollY > 10 });
  };

  handleClickOutside = (event) => {
    if (this.profileRef.current && !this.profileRef.current.contains(event.target)) {
      this.setState({ profileOpen: false });
    }
    const openMenu = document.querySelector(".desktop-nav .nav-group-menu[open]");
    if (openMenu && !openMenu.contains(event.target)) this.closeDesktopMenus();
  };

  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      this.closeMenu();
      this.closeProfile();
      this.closeDesktopMenus();
    }
  };

  closeDesktopMenus = () => {
    document.querySelectorAll(".desktop-nav .nav-group-menu[open]").forEach((menu) => {
      menu.open = false;
    });
  };

  handleNavGroupToggle = (event) => {
    if (!event.currentTarget.open) return;
    document.querySelectorAll(".desktop-nav .nav-group-menu[open]").forEach((menu) => {
      if (menu !== event.currentTarget) menu.open = false;
    });
  };

  toggleMenu = () => {
    this.setState((prev) => {
      const menuOpen = !prev.menuOpen;
      document.body.style.overflow = menuOpen ? "hidden" : "";
      return { menuOpen };
    }, () => {
      const target = this.state.menuOpen ? this.closeButtonRef.current : this.menuButtonRef.current;
      target?.focus();
    });
  };

  closeMenu = () => {
    const wasOpen = this.state.menuOpen;
    this.setState({ menuOpen: false });
    document.body.style.overflow = "";
    if (wasOpen) this.menuButtonRef.current?.focus();
  };

  toggleProfile = () => {
    this.setState((prev) => ({ profileOpen: !prev.profileOpen }));
  };

  closeProfile = () => {
    this.setState({ profileOpen: false });
  };

  logout = () => {
    const { handleLogout } = this.props.auth;
    handleLogout();
    this.props.navigate("/login");
  };

  isActive = (item) => {
    if (this.props.location.pathname !== item.path) return false;
    return item.search ? this.props.location.search === item.search : true;
  };

  render() {
    const { user } = this.props.auth;
    const { menuOpen, profileOpen, scrolled } = this.state;

    const customerMustChangePassword = user?.role === "customer" && user?.must_change_password;
    const navGroups = [
      { label: "Overview", items: [
        { key: "dashboard", label: "Dashboard", path: "/dashboard", icon: <DashboardIcon /> },
      ] },
      { label: "Operations", items: [
        { key: "capture", label: "Bunch capture", path: "/capture", icon: <CaptureIcon /> },
        { key: "harvest_data_capture", label: "Field harvest", path: "/harvest-data-capture", icon: <HarvestIcon /> },
        { key: "intake_qc", label: "Intake QC", path: "/intake-qc", icon: <QCIcon /> },
        { key: "session", label: "Packhouse session", path: "/session", icon: <SessionIcon /> },
        { key: "rejections", label: "Packhouse rejections", path: "/rejections", icon: <RejectionsIcon /> },
        { key: "capture", label: "Live bunchers", path: "/live/bunchers", icon: <CaptureIcon /> },
      ] },
      { label: "Analytics", items: [
        { key: "analytics", label: "Packhouse analytics", path: "/analytics/main", icon: <DashboardIcon /> },
        { key: "buncher_performance", label: "Field performance", path: "/analytics/bunchers", icon: <HarvestIcon /> },
        { key: "intake_analytics", label: "Intake analytics", path: "/analytics/intake", icon: <QCIcon /> },
        { key: "rejections_analytics", label: "Rejection analytics", path: "/analytics/rejections", icon: <RejectionsIcon /> },
      ] },
      { label: "Management", items: [
        { key: "manage", label: "Manage", path: "/manage", icon: <ManageIcon /> },
      ] },
      { label: "Administration", items: [
        { key: "users", label: "Users & access", path: "/users", icon: <UsersIcon /> },
      ] },
      { label: user?.role === "customer" ? "My account" : "Clients", items: customerMustChangePassword ? [
        { key: "client_portal", label: "Set password", path: "/clients/password", icon: <UsersIcon /> },
      ] : user?.role === "customer" ? [
        { key: "client_portal", label: "Order flowers", path: "/clients", search: "?tab=shop", icon: <UsersIcon /> },
        { key: "client_portal", label: "My orders", path: "/clients", search: "?tab=my-orders", icon: <SessionIcon /> },
        { key: "client_portal", label: "Dispatch reminders", path: "/clients", search: "?tab=preferences", icon: <DashboardIcon /> },
      ] : [
        { key: "client_portal", right: "clients.manage", label: "Customer accounts", path: "/clients", search: "?tab=customers", icon: <UsersIcon /> },
        { key: "client_portal", right: "clients.catalog", label: "Product catalogues", path: "/clients", search: "?tab=catalog", icon: <LeafIcon /> },
        { key: "client_portal", right: "clients.orders", label: "Client orders", path: "/clients", search: "?tab=orders", icon: <SessionIcon /> },
        { key: "client_portal", right: "clients.setup", label: "Categories & dispatch", path: "/clients", search: "?tab=setup", icon: <ManageIcon /> },
      ] },
    ];

    const visibleGroups = navGroups.map((group) => ({
      ...group,
      items: group.items.filter((item) => {
        if (item.right) return canAccess(user, item.key) && Boolean(user?.is_superuser || user?.role === "admin" || user?.access_rights?.[item.right]);
        if (item.key === "harvest_data_capture") return this.state.harvestAccess || canAccess(user, item.key);
        return canAccess(user, item.key);
      }),
    })).filter((group) => group.items.length > 0);
    const roleLabel = user?.customer_company || user?.department || user?.role?.replaceAll("_", " ");

    return (
      <>
        {/* Main Navbar */}
        <nav className={`smart-navbar ${scrolled ? "scrolled" : ""}`} aria-label="Main navigation">
          <div className="navbar-inner">
            {/* Brand */}
            <Link to="/" className="navbar-brand" onClick={this.closeMenu}>
              <div className="brand-icon">
                <LeafIcon />
              </div>
              <div className="brand-text">
                <span className="brand-name">SmartHarvest</span>
                <span className="brand-tagline">Quality First</span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="desktop-nav">
              <ul className="nav-pills nav-groups">
                {visibleGroups.map((group) => {
                  const groupActive = group.items.some((item) => this.isActive(item));
                  return (
                    <li className="nav-group" key={group.label}>
                      <details className="nav-group-menu" onToggle={this.handleNavGroupToggle}>
                        <summary className={`nav-group-trigger ${groupActive ? "active" : ""}`}>
                          {group.label}<span className="nav-group-chevron"><ChevronDownIcon /></span>
                        </summary>
                        <div className="nav-group-panel">
                          {group.items.map((item) => (
                            <Link key={`${item.label}-${item.search || ""}`} to={{ pathname: item.path, search: item.search || "" }} className={`nav-group-link ${this.isActive(item) ? "active" : ""}`} onClick={this.closeDesktopMenus}>
                              <span className="pill-icon">{item.icon}</span><span>{item.label}</span>
                            </Link>
                          ))}
                        </div>
                      </details>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Right Section */}
            <div className="navbar-actions">
              {user && (
                <div className="user-section" ref={this.profileRef}>
                  <button 
                    className={`user-trigger ${profileOpen ? "open" : ""}`}
                    onClick={this.toggleProfile}
                  >
                    <div className="user-avatar">
                      {user.username?.charAt(0).toUpperCase()}
                    </div>
                    <div className="user-meta">
                      <span className="user-name">{user.username}</span>
                      <span className="user-role">{roleLabel}</span>
                    </div>
                    <span className="user-chevron">
                      <ChevronDownIcon />
                    </span>
                  </button>

                  {/* Profile Dropdown */}
                  <div className={`profile-dropdown ${profileOpen ? "show" : ""}`}>
                    <div className="dropdown-header">
                      <div className="dropdown-avatar">
                        {user.username?.charAt(0).toUpperCase()}
                      </div>
                      <div className="dropdown-info">
                        <span className="dropdown-name">{user.username}</span>
                        <span className="dropdown-role">
                          {user.role.replaceAll("_", " ").toUpperCase()}{user.department ? ` • ${user.department}` : user.customer_company ? ` • ${user.customer_company}` : ""}
                        </span>
                      </div>
                    </div>
                    <div className="dropdown-divider" />
                    <button className="dropdown-action logout" onClick={this.logout}>
                      <LogoutIcon />
                      <span>Sign Out</span>
                    </button>
                  </div>
                </div>
              )}

              {/* Mobile Hamburger */}
              <button
                ref={this.menuButtonRef}
                className={`hamburger-btn ${menuOpen ? "open" : ""}`}
                onClick={this.toggleMenu}
                aria-label={menuOpen ? "Close navigation" : "Open navigation"}
                aria-expanded={menuOpen}
                aria-controls="smart-mobile-navigation"
              >
                {menuOpen ? <CloseIcon /> : <MenuIcon />}
              </button>
            </div>
          </div>
        </nav>

        {/* Mobile Sidebar Overlay */}
        <button 
          className={`sidebar-overlay ${menuOpen ? "show" : ""}`}
          onClick={this.closeMenu}
          aria-label="Close navigation"
          tabIndex={menuOpen ? 0 : -1}
        />

        {/* Mobile Sidebar */}
        <aside id="smart-mobile-navigation" className={`mobile-sidebar ${menuOpen ? "open" : ""}`} role="dialog" aria-modal="true" aria-label="Navigation menu" aria-hidden={!menuOpen} inert={!menuOpen ? "" : undefined}>
          <div className="sidebar-header">
            <div className="sidebar-brand">
              <div className="brand-icon">
                <LeafIcon />
              </div>
              <span>SmartHarvest</span>
            </div>
            <button ref={this.closeButtonRef} className="sidebar-close" onClick={this.closeMenu} aria-label="Close navigation">
              <CloseIcon />
            </button>
          </div>

          <div className="sidebar-user">
            {user && (
              <div className="sidebar-user-card">
                <div className="sidebar-avatar">
                  {user.username?.charAt(0).toUpperCase()}
                </div>
                <div className="sidebar-user-info">
                  <span className="sidebar-user-name">{user.username}</span>
                  <span className="sidebar-user-role">
                    {user.role.replaceAll("_", " ").toUpperCase()}{user.department ? ` / ${user.department}` : user.customer_company ? ` / ${user.customer_company}` : ""}
                  </span>
                </div>
              </div>
            )}
          </div>

          <nav className="sidebar-nav" aria-label="All modules">
            {visibleGroups.map((group) => (
              <section className="sidebar-nav-group" key={group.label}>
                <h2>{group.label}</h2>
                {group.items.map((item) => (
                  <Link key={`${item.label}-${item.search || ""}`} to={{ pathname: item.path, search: item.search || "" }} className={`sidebar-link ${this.isActive(item) ? "active" : ""}`} onClick={this.closeMenu}>
                    <span className="sidebar-link-icon">{item.icon}</span>
                    <span className="sidebar-link-label">{item.label}</span>
                    {this.isActive(item) && <span className="sidebar-link-active" />}
                  </Link>
                ))}
              </section>
            ))}
          </nav>

          <div className="sidebar-footer">
            <button className="sidebar-logout" onClick={this.logout}>
              <LogoutIcon />
              <span>Sign Out</span>
            </button>
          </div>
        </aside>

        {/* Spacer for fixed navbar */}
        <div className="navbar-spacer" />
      </>
    );
  }
}

const NavbarWrapper = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  return <Navbar auth={auth} navigate={navigate} location={location} />;
};

export default NavbarWrapper;
